module.exports = __webpack_public_path__ + "img/einlagern.988ce069.svg";